"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WechatAppletsLoginOutRequest = void 0;
var WechatAppletsLoginOutRequest = /** @class */ (function () {
    function WechatAppletsLoginOutRequest() {
    }
    return WechatAppletsLoginOutRequest;
}());
exports.WechatAppletsLoginOutRequest = WechatAppletsLoginOutRequest;
;
//# sourceMappingURL=wechatAppletsLoginOut.request.js.map